"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineResponse2007 = void 0;
const ilead_type_cost_entity_1 = require("./ilead-type-cost-entity");
function parseInlineResponse2007(data) {
    if (data.records !== null && typeof data.records === 'object')
        data.records = data.records.map((x) => (0, ilead_type_cost_entity_1.parseILeadTypeCostEntity)(x));
    return data;
}
exports.parseInlineResponse2007 = parseInlineResponse2007;
